import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createHashRouter, RouterProvider } from 'react-router'
import '@fontsource/nunito-sans/700.css'
import '@fontsource/roboto'
import '@fontsource/roboto-mono'

import './index.css'
import App from './App'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { storeWithRoutes, RouteContext } from './store'
import { mixpanel } from './mixpanel'
import { MixpanelProvider } from 'common-ui/mixpanel'

const container = document.getElementById('root')
const root = createRoot(container!)
const router = createHashRouter([{ path: '*', element: <App /> }])

root.render(
  <StrictMode>
    <Provider store={storeWithRoutes.store}>
      <RouteContext.Provider value={{ routes: storeWithRoutes.routes }}>
        <DndProvider backend={HTML5Backend}>
          <MixpanelProvider value={mixpanel}>
            <RouterProvider router={router} />
          </MixpanelProvider>
        </DndProvider>
      </RouteContext.Provider>
    </Provider>
  </StrictMode>,
)

mixpanel.init()
